module.exports = __webpack_public_path__ + "img/tablist-ico02-active.388369a2.png";